export const NAVBAR_BLOCK_s1 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#111111",
    "padding": "0px 0px 0px 0px",
    "border-bottom": "1px solid #ffffff"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "About Us",
      "linkUrl": "/about",
      "styleProps": {
        "color": "#ffffff",
        "border-left": "1px solid #ffffff",
        "padding": "30px 30px 30px 30px",
        "border-right": ""
      },
      "sectionID": "aboutsection",
      "stylePropsMob": {
        "border-left": "0px solid #ffffff"
      }
    },
    {
      "text": "Contact Us",
      "linkUrl": "/contact",
      "styleProps": {
        "color": "#ffffff",
        "border-left": "1px solid #ffffff",
        "padding": "30px 30px 30px 30px",
        "border-right": ""
      },
      "sectionID": "aboutsection",
      "stylePropsMob": {
        "border-left": "0px solid #ffffff"
      }
    },
    {
      "text": "Signup",
      "linkUrl": "/signup",
      "styleProps": {
        "color": "#ffffff",
        "border-left": "1px solid #ffffff",
        "padding": "30px 30px 30px 30px",
        "border-right": "1px solid #ffffff"
      },
      "sectionID": "aboutsection",
      "stylePropsMob": {
        "border-right": "0px solid #ffffff",
        "border-left": "0px solid #ffffff"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#ffffff",
    "border-color": ""
  },
  "metaDataId": 1746259444862,
  "afterIndex": 0,
  "blockId": 1746259444862,
  "linkItemStyleProps": {
    "color": "#ffa611"
  },
  "linksStyleProps": {
    "color": "#ffa611",
    "background-color": ""
  }
}
